import { BadgeOfferingModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class BadgeOfferingService extends ApiService<BadgeOfferingModel> {
	constructor() {
		super('badgeoffering');
	}
}

export default new BadgeOfferingService();
